import { render } from "./Recapitulatif.vue?vue&type=template&id=57c42f15&scoped=true&ts=true"
import script from "./Recapitulatif.vue?vue&type=script&lang=ts"
export * from "./Recapitulatif.vue?vue&type=script&lang=ts"

import "./Recapitulatif.vue?vue&type=style&index=0&id=57c42f15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c42f15"]])

export default __exports__